<script setup>
import GenericDataFieldsWrapper from './GenericDataFieldsWrapper.vue';
import TeamsDataFields from './TeamsDataFields.vue';

const emit = defineEmits(['update', 'validation', 'show-team-info']);

const props = defineProps({
  initialTeamFields: {
    type: Array,
    default: () => ([]) // Inicia vazio, times são opcionais
  },
  isEditMode: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <GenericDataFieldsWrapper
    :initial-fields="initialTeamFields"
    :is-edit-mode="isEditMode"
    field-type="team"
    :child-component="TeamsDataFields"
    store-getter="teams/getTeams"
    store-action="teams/get"
    :excluded-titles="[]"
    add-button-label="Adicionar Configuração de Time"
    @update="(fields) => emit('update', fields)"
    @validation="(isValid) => emit('validation', isValid)"
    @show-info="() => emit('show-team-info')"
  />
</template>